import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { AlertService, ReportsService } from 'src/app/shared';

@Component({
  selector: 'app-cand-exam-res',
  templateUrl: './cand-exam-res.component.html',
  styleUrls: ['./cand-exam-res.component.scss']
})
export class CandExamResComponent implements OnInit, OnDestroy {

  sub:any;
  

  center:any;
  batch:any;
  candidate:any;
  model:any;

  sections:any = [];
  answers:any = [];

  constructor(
    private activateRoute: ActivatedRoute,
    private alert:AlertService, 
    private router: Router,
    private reportService: ReportsService
    ) { }

  ngOnInit() {
    this.sub  = this.activateRoute.paramMap.subscribe (res=>{

      this.center = res.get ("center");
      this.batch = res.get ("batch");
      this.candidate = res.get ("candidate"); 
      this.getReport (); 
    });

  }

  getReport (){

    //var p = this.path + "/candidate/" + data.center + "/" + data.batch + "/" + data.candidate;
    var data = {
      center: this.center, 
      batch: this.batch, 
      candidate: this.candidate
    };

    this.reportService.getCandidateReport (data)
    .pipe (first())
    .subscribe (res =>{
      this.model = res || {};
      if (this.model.result && this.model.result.finalAns){
        this.sections = this.model.result.finalAns || [];
      }else {
        this.sections = this.model.result || [];
      }
      
      console.log ("what is secitons ...", this.sections);
       this.answers = this.model.answers;

    });
  }


  getAnswers (ans){
    if (ans && ans.id){
      return ans.id;
    }

    //see if it is multi choice.
    if (ans && Array.isArray  (ans)){
      var x = "";
      for (var i=0; i<ans.length; i++){
        x += ans [i].id;
        if (i != ans.length -1){
          x += ", ";
        }
      }
      return x;
    }

    return "---";
  }


  ngOnDestroy (){
    if (this.sub){
      this.sub.unsubscribe ();
    }
  }
}
